/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Race_ListenInputs */

const en_funnel_ob_race_listen = /** @type {(inputs: Funnel_Ob_Race_ListenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening at 1.75×`)
};

const es_funnel_ob_race_listen = /** @type {(inputs: Funnel_Ob_Race_ListenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escuchando a 1,75×`)
};

/**
* | output |
* | --- |
* | "Listening at 1.75×" |
*
* @param {Funnel_Ob_Race_ListenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_race_listen = /** @type {((inputs?: Funnel_Ob_Race_ListenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Race_ListenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_race_listen(inputs)
	return en_funnel_ob_race_listen(inputs)
});